// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + {"494":"9b265e6586a7e912719a","701":"9560839e680f65f6a3dc"}[chunkId] + ".js";
};